import React from 'react';

const TeamTable = ({ players, abbr, color, onPlayerClick }) => (
  <div className="flex-1 min-w-0">
    <div className="px-2 py-1.5 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
      <span className="text-[10px] font-black uppercase tracking-widest" style={{ color }}>{abbr}</span>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-center" style={{ minWidth: '280px' }}>
        <thead>
          <tr className="text-[#658d71] text-[8px] uppercase tracking-widest border-b border-[rgba(101,141,113,0.3)]">
            <th className="px-2 py-1.5 text-left">Player</th>
            {['AB', 'H', 'HR', 'RBI', 'BB', 'K', 'AVG'].map(h => (
              <th key={h} className="px-1 py-1.5 w-7">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {players.map((p, i) => (
            <tr
              key={i}
              onClick={() => p.id && onPlayerClick?.(p.id, p.name)}
              className="border-b border-[rgba(101,141,113,0.15)] last:border-0 cursor-pointer hover:bg-[rgba(255,255,255,0.03)] group"
            >
              <td className="px-2 py-1.5 text-left">
                <span className="text-[10px] font-black text-white uppercase tracking-wide group-hover:text-[#d8ceb3] transition-colors truncate block max-w-[80px]">
                  {p.name.split(' ').pop()}
                </span>
                <span className="text-[8px] text-[#658d71] font-bold">{p.pos}</span>
              </td>
              {[p.ab, p.h, p.hr || '–', p.rbi || '–', p.bb || '–', p.k || '–'].map((v, j) => (
                <td key={j} className={`px-1 py-1.5 text-[10px] tabular-nums font-bold ${
                  j === 1 && p.h > 0 ? 'text-[#d8ceb3]' : 'text-[#a9c9b1]'
                }`}>{v}</td>
              ))}
              <td className="px-1 py-1.5 text-[10px] tabular-nums font-black text-[#d8ceb3]">
                {p.avg}
              </td>
            </tr>
          ))}
          {!players.length && (
            <tr>
              <td colSpan={8} className="py-4 text-[#658d71] text-[9px] uppercase tracking-widest text-center">
                No data
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

const PlayerHitLines = ({ playerLines, awayAbbr, homeAbbr, onPlayerClick }) => (
  <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
    <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
      <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Batting Lines</span>
      <p className="text-[8px] text-[#658d71] font-bold uppercase tracking-widest mt-0.5">
        Click any player to view profile
      </p>
    </div>
    <div className="flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-[rgba(101,141,113,0.3)]">
      <TeamTable players={playerLines.away} abbr={awayAbbr} color="#a9c9b1" onPlayerClick={onPlayerClick} />
      <TeamTable players={playerLines.home} abbr={homeAbbr} color="#c4333e" onPlayerClick={onPlayerClick} />
    </div>
  </div>
);

export default PlayerHitLines;